<template>
    <div>
        <div class="toolbox-button" @click="handleClick" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
          <template v-if="loading">
            <icon :icon="['fal', 'spinner']" spin/>
          </template>
          <template v-else>
            <slot/>
          </template>
        </div>


        <template v-if="showProtectedMessage">
            <div class="confirmation-panel">

            </div>
            <div class="confirmation-box">
                <div style="margin-bottom: 10px;">
                {{protectedMessage}}
                </div>
                <simple-layout horizontal>
                    <simple-button @press="() => showProtectedMessage = false">{{$t("cancel")}}</simple-button>
                    <simple-button @press="sendPressEvent" ref="confirmButton">{{ $t("yes") }}</simple-button>
                </simple-layout>
            </div>

        </template>
    </div>
</template>

<script>
    import SimpleButton from "../button/SimpleButton";
    import SimpleLayout from "../layout/SimpleLayout";
    export default {
        name: "ToolboxButton",
        components: {SimpleLayout, SimpleButton},
        data: function () {
            return {
              showProtectedMessage: false,
              loading: false
            }
        },
        props: {
            helpText: String,
            protectedMessage: String
        },
        inject: {
            showHelp: 'showHelp',
            clearHelp: 'clearHelp'
        },
        methods: {
            async handleClick() {
              if(this.disabled) return;
              if(this.protectedMessage != undefined) {
                this.showProtectedMessage = true;
                window.addEventListener("mousedown", this.blurConfirmationMessage)
                return;
              }
              this.loading = true;
              try {
                await this.sendPressEvent();
              }
              catch(err) {
                this.error = true;
              }
              finally {
                this.loading = false;
              }


            },
            blurConfirmationMessage(e) {
                if(e.target.parents(this.$refs.confirmButton.$el)) {
                    return;
                }
                this.showProtectedMessage = false;
                window.removeEventListener("mousedown", this.blurConfirmationMessage);
            },
            async sendPressEvent() {
                if(this.showProtectedMessage) {
                    window.removeEventListener("mousedown", this.blurConfirmationMessage);
                }
                this.showProtectedMessage = false;
                return await this.$listeners.press();
            },
            handleMouseEnter() {
                this.showHelp(this.helpText);
            },
            handleMouseLeave() {
                this.clearHelp();
            }

        }
    }
</script>

<style lang="scss" scoped>
.toolbox-button {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center;
    background-color: lighten(#262C32, 17);
    border: 1px solid lighten(#262C32, 17);
    border-radius: 5px;
}

.toolbox-button:hover {
    cursor: pointer;
    background-color: lighten(#262C32, 5);
    border: 1px solid lighten(#262C32, 5);
}

.confirmation-panel {
    z-index: 11;
    position: absolute;
    top: 36px;
    width: 30px;
    height: 20px;
    background-color: lighten(#262C32, 17);

}

.confirmation-box {
    z-index: 10;
    position: absolute;
    min-width: 200px;
    top: 52px;
    background-color: lighten(#262C32, 17);
    padding: 10px;
    border-bottom-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    box-shadow: #00000055 3px 3px 5px;
}

</style>